import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { Nav, Button, ButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faArrowRight,
  faInfoSquare,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

import TitleBar from './TitleBar';

import './Tutorial.sass';

class Tutorial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pinned: true,
      expanded: true,
    };
  }

  togglePin = () => {
    this.setState({ pinned: !this.state.pinned });
  };

  toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  renderNav() {
    return (
      <TitleBar
        enableBack={!!this.props.selected}
        pinned={this.state.pinned}
        togglePin={this.togglePin}
        back={() => this.props.openHelp(null)}
        close={() => this.props.closeHelp()}
      />
    );
  }

  render() {
    // don't render anything if help is not open
    if (!this.props.isOpen) {
      return null;
    }

    let mouseenter, mouseleave;

    if (!this.state.pinned) {
      if (this.state.expanded) {
        mouseleave = this.toggleExpand;
      } else {
        mouseenter = this.toggleExpand;
      }
    }

    let content;
    if (!!this.props.selected) {
      const url = this.props.baseUrl + '/' + this.props.selected + '.html';
      content = <iframe src={url} title={this.props.selected} />;
    } else {
      let links = this.props.toc.map((item) => (
        <Nav.Link key={item.id} eventKey={item.code} title={item.name}>
          <FontAwesomeIcon icon={faInfoSquare} /> {item.name}
        </Nav.Link>
      ));
      content = (
        <Nav
          className="flex-column"
          variant="pills"
          size="sm"
          onSelect={(code) => this.props.openHelp(code)}
        >
          {links}
        </Nav>
      );
    }

    return (
      <div
        className={`d-flex flex-column justify-content-between help-container border-start ${
          this.state.expanded ? '' : 'collapsed'
        }`}
        onMouseEnter={mouseenter}
        onMouseLeave={mouseleave}
        role="complementary"
        aria-label="Help and tutorials"
      >
        <div className="flex-grow-1 d-flex flex-column">
          {this.state.expanded ? (
            this.renderNav()
          ) : (
            <i className="fa fa-life-ring" style={{ fontSize: '20px' }} />
          )}

          {content}
        </div>

        <div className="flex-grow-0 w-100">
          <ButtonGroup size="md" className="d-flex">
            <Button onClick={this.props.prevExercise} variant="secondary">
              <FontAwesomeIcon icon={faArrowLeft} /> Previous
            </Button>
            <Button onClick={this.props.nextExercise} variant="secondary">
              Next <FontAwesomeIcon icon={faArrowRight} />
            </Button>
          </ButtonGroup>
        </div>
      </div>
    );
  }
}

Tutorial.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  toc: PropTypes.array,
  prevExercise: PropTypes.func,
  nextExercise: PropTypes.func,
  openHelp: PropTypes.func,
  closeHelp: PropTypes.func,
};

Tutorial.defaultProps = {
  isOpen: false,
  toc: [],
};

export default Tutorial;
